
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 6 2.36"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 2.36L.72.28h1.15L6-.04v.26L5 1.57z"}})])
          )
        }
      }
    